import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { Unit } from '@dynatrace-sdk/units';

import type { Formatter } from '../../core/types/formatter.js';
import { DEFAULT_AGGREGATED_LABEL } from '../constants.js';
import type { InternalTreeMapNode } from '../types/internal.js';

const getTooltipItemId = (
  content?: HierarchyRectangularNode<InternalTreeMapNode>,
) => {
  const isCluster = content?.data.children?.length;
  const parentName = content?.parent?.data.name;
  const nodeName = content?.data.name;
  const nodeValue = content?.data.value;

  const isAggregatedNode = nodeName === DEFAULT_AGGREGATED_LABEL;
  const isAggregatedChild =
    content?.data.children?.[0].name === DEFAULT_AGGREGATED_LABEL;
  const isChildOfAggregatedCluster = parentName === DEFAULT_AGGREGATED_LABEL;
  const isAggregatedCluster = isAggregatedNode && isAggregatedChild;

  if (isChildOfAggregatedCluster || isAggregatedCluster) {
    return `other-cluster-${nodeValue}`;
  }
  if (isAggregatedNode) {
    return `other-${parentName}-${nodeValue}`;
  }
  if (isCluster) {
    return `cluster-${nodeName}-${nodeValue}`;
  }
  return `${parentName}-${nodeName}-${nodeValue}`;
};

export const getTooltipItem = (
  formatter: Formatter,
  content?: HierarchyRectangularNode<InternalTreeMapNode>,
  unit?: string | Unit,
) => ({
  id: getTooltipItemId(content),
  name: content?.data.name ?? '-',
  values: [formatter(content?.data.value ?? 0, unit)],
});
